import { render, staticRenderFns } from "./PortalLinkMenusPanel.vue?vue&type=template&id=261d7b74&scoped=true&"
import script from "./PortalLinkMenusPanel.vue?vue&type=script&lang=ts&"
export * from "./PortalLinkMenusPanel.vue?vue&type=script&lang=ts&"
import style0 from "./PortalLinkMenusPanel.vue?vue&type=style&index=0&id=261d7b74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261d7b74",
  null
  
)

export default component.exports